import React, { useState } from "react";
import DiaglogBox from "../../atoms/DiaglogBox";
import Button from "../../atoms/Button";
import UploadDocumentItem from "../DocumnetUploadDialogBox/UploadDocumentItem";
import { ReactComponent as Arrow } from "../../svgs/tableArrow.svg";
import { LoadingOutlined } from "@ant-design/icons";
import toast from "react-hot-toast";
import { submitCompleteBidDocs } from "../../../utils/API/submitCompleteBidDocs";
import { useDispatch } from "react-redux";

const docs = [
  {
    name: "acknowledgement",
    label: "Acknowledgement",
    number: 1,
    allowedFileTypes: [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "application/pdf",
    ],
  },
  {
    name: "document_one",
    label: "Document 1",
    number: 1,
    allowedFileTypes: [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "application/pdf",
    ],
  },
  {
    name: "document_two",
    label: "Document 2",
    number: 1,
    allowedFileTypes: [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "application/pdf",
    ],
  },
];

const UploadCompleteBidsDocuments = ({ open, onCancel, data }) => {
  const dispatch = useDispatch();
  const [uploadedDocuments, setUploadedDocuments] = useState({
    acknowledgement: [],
    document_one: [],
    document_two: [],
  });

  const handleDocumentCancel = () => {
    setUploadedDocuments({
      acknowledgement: [],
      document_one: [],
      document_two: [],
    });
    onCancel();
  };

  const handleSubmit = async () => {
    try {
      if (
        uploadedDocuments.acknowledgement.length > 0 &&
        uploadedDocuments.document_one.length > 0 &&
        uploadedDocuments.document_two.length > 0
      ) {
        const formData = {
          acknowledgement: uploadedDocuments.acknowledgement[0].url,
          document_one: uploadedDocuments.document_one[0].url,
          document_two: uploadedDocuments.document_two[0].url,
        };
        const response = await submitCompleteBidDocs({
          transactionId: data,
          formData,
          dispatch,
        });
        toast.success("Documents submitted successfully!");
        handleDocumentCancel();
      } else {
        toast.error("Upload all 3 documents to submit data");
      }
    } catch (error) {
      toast.error("Documents are unable to  submit ");
    }
  };
  return (
    <DiaglogBox open={open} onCancel={handleDocumentCancel} width={450}>
      <div className="py-4">
        <div className="px-6 py-4">
          <div className="flex border-b-2">
            <div className="w-[50%] pl-6 flex items-center font-bold">
              <Arrow className="h-2 w-2 mr-1" />
              Documents
            </div>
            <div className="w-[50%] justify-center flex items-center font-bold">
              <Arrow className="h-2 w-2 mr-1" />
              Actions
            </div>
          </div>
          {docs.map(({ label, number, name, allowedFileTypes }) => {
            return (
              <UploadDocumentItem
                label={label}
                number={number}
                allowedFileTypes={allowedFileTypes}
                name={name}
                setDocuments={setUploadedDocuments}
                uploadList={uploadedDocuments[name]}
              />
            );
          })}
        </div>
        <div className="text-center ">
          <Button
            onClick={handleSubmit}
            variant="primary"
            color="blue"
            className="mt-2 w-36 h-10 mb-2 inline-block text-white text-center text-base font-bold leading-4 mx-2 rounded-md"
          >
            Submit
          </Button>
          <Button
            onClick={handleDocumentCancel}
            variant="primary"
            color="white"
            className="w-36 h-10 mb-2 inline-block text-blue-500 text-center text-base font-bold leading-4 mx-2 border border-solid border-blue-500 rounded-md"
          >
            Cancel
          </Button>
        </div>
      </div>
    </DiaglogBox>
  );
};

export default UploadCompleteBidsDocuments;
